import { useWidgetData } from '../useWidgetData'

import { RemainingMinutesWidget } from '../../../types/widget/widget'

export const useRemainingMinutesWidget = () =>
  useWidgetData<RemainingMinutesWidget>('remaining-minutes')
